import Script, { ScriptProps } from "next/script";
/**
 * script内联代码
 * @param props
 * @returns
 */

interface IProps extends ScriptProps {
  children?: any;
}

const ScriptCustomize = (props: IProps) => {
  const {
    children,
    id = Math.random().toString(36).slice(2),
    ...resetProps
  } = props;

  return (
    <Script
      id={id}
      {...resetProps}
      dangerouslySetInnerHTML={{
        __html: children ? `(${children.toString()})();` : "",
      }}
    ></Script>
  );
};

export default ScriptCustomize;
